import { set, toggle } from '@/utils/vuex'

export default {
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  setCourseSubjectList: set('courseSubjectList'),
  setSubjectListNotInCourse: set('subjectListNotInCourse')
}
